import React, { memo } from 'react';
import { Dropdown, Menu, Tooltip } from 'antd';
// import { findParentNode } from '@utils';

const ActionButton = memo(
  ({ add, deleteCurrent, type = 'Row', style = {}, addBtnDisabled }) => {
    const isColumn = type === 'Column';
    // const menu = (
    //   <Menu style={{ width: '10.5rem', fontSize: '0.8rem' }}>
    //     <Menu.Item onClick={add} disabled={addBtnDisabled} key="add">
    //       Add {type}
    //     </Menu.Item>
    //     <Menu.Item onClick={deleteCurrent} key="delete">
    //       Delete Current {type}
    //     </Menu.Item>
    //   </Menu>
    // );
    return (
      <div
        className="row-operate"
        style={isColumn ? { textAlign: 'right' } : undefined}
      >
        <Tooltip
          title={<span className="row-operate-tooltip">Add {type}</span>}
          key="add"
          overlayClassName="row-operate-tooltip-overlay"
          // getPopupContainer={(triggerNode) =>
          //   findParentNode(triggerNode, 'text-container')
          // }
        >
          <span className="appkiticon icon-plus-outline" onClick={add} />
        </Tooltip>
        <Tooltip
          title={<span className="row-operate-tooltip">Delete {type}</span>}
          key="delete"
          overlayClassName="row-operate-tooltip-overlay"
          // getPopupContainer={(triggerNode) =>
          //   findParentNode(triggerNode, 'text-container')
          // }
        >
          <span
            className="appkiticon icon-minus-outline"
            onClick={deleteCurrent}
          />
        </Tooltip>
        {/*<Dropdown*/}
        {/*  overlay={menu}*/}
        {/*  placement={isColumn ? 'bottomRight' : 'topLeft'}*/}
        {/*  getPopupContainer={(triggerNode) => findParentNode(triggerNode, 'text-container')}*/}
        {/*>*/}
        {/*  <span className="appkiticon icon-horizontal-more-fill" />*/}
        {/*</Dropdown>*/}
      </div>
    );
  },
);

export default ActionButton;
